module.exports = __webpack_public_path__ + "static/media/Kissen_70x70.d469590a.png";